import { createContext } from 'react';

/** Lets a summoned card pulse its filament back to Anna when its data changes. */
export const CardPingContext = createContext<() => void>(() => undefined);
